var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Col, Row } from "react-bootstrap";
import withBranding from "@irati/brand/withBranding";
import authentication from "@irati/auth";
import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import hasPerksGOLocations from "@irati/deals/helpers/deals/hasPerksGOLocations";
import id from "@irati/utils/id";
import { determineDealThumbnailImage } from "@irati/deals/helpers/deals/appearance";
import { isUserDOBRequired } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import Flex from "@irati/ui/src/Flex";
import ThumbnailCol from "./styled/ThumbnailCol";
import DealHeaderDetails from "../../components/DealHeaderDetails";
import DealImportantInfoContainer from "../../containers/DealImportantInfoContainer";
import DEAL_MODES from "../../constants/dealMode";
import DealDescription from "./DealDescription";
import DeliveryInfo from "./DeliveryInfo";
import BirthdayBox from "./BirthdayBox";
import FAQ from "./FAQ";
import HowItWorks from "./HowItWorks";
import ContactInfo from "./ContactInfo";
import UnavailableDeal from "./UnavailableDeal";
import DealLocations from "../DealLocations/DealLocations";
import { DealAvatar } from "./styled/DealInfoBlock";
var DealInfoBlock = /** @class */ (function (_super) {
    __extends(DealInfoBlock, _super);
    function DealInfoBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showLocations = function () {
            return authentication.apps("platform.geoLocation") && authentication.apps("perks.perksGo") && hasPerksGOLocations(_this.props.deal);
        };
        _this.isPerksGoDeal = function (deal) {
            return authentication.apps("perks.perksGo") && isPerksGO(deal);
        };
        _this.showImportantInfo = function () {
            var deal = _this.props.deal;
            return _this.isPerksGoDeal(deal) || isUserDOBRequired(deal) || isAppOnly(deal) || isDealUnavailable(deal);
        };
        _this.showBirthdayBox = function () {
            var _a;
            return !!((_a = _this.props.deal) === null || _a === void 0 ? void 0 : _a.isBirthdayBox);
        };
        return _this;
    }
    DealInfoBlock.prototype.render = function () {
        var _a = this.props, deal = _a.deal, user = _a.user, branding = _a.branding;
        var thumbnailImageSrc = determineDealThumbnailImage(deal, branding);
        var idNamespace = id("deal-info-block", this.props);
        return (React.createElement(Row, { className: "dealInfoBlock" },
            React.createElement(Col, { md: 12 },
                React.createElement(Row, null,
                    React.createElement(ThumbnailCol, { md: 4, sm: 4, xs: 12 }, thumbnailImageSrc && (React.createElement(DealAvatar, { "data-test": "top-thumbnail", src: thumbnailImageSrc, className: "dealInfoBlock_dealThumbnail", withShadow: true }))),
                    React.createElement(Col, { md: 8, sm: 8, xs: 12, className: "dealInfoBlock_dealHighlight" },
                        React.createElement(DealHeaderDetails, { deal: deal, mode: DEAL_MODES.FULL_PAGE }))),
                isDealUnavailable(deal) && (React.createElement(Row, null,
                    React.createElement(Flex, { margin: "30px 0px 0px 0px" },
                        React.createElement(Col, { xs: 12 },
                            React.createElement(UnavailableDeal, null))))),
                React.createElement(DealDescription, { deal: deal }),
                this.showBirthdayBox() && React.createElement(BirthdayBox, { metadata: deal.birthdayBoxMetaData }),
                React.createElement(HowItWorks, { deal: deal }),
                React.createElement(DeliveryInfo, { deal: deal }),
                this.showLocations() && (React.createElement(DealLocations, { deal: deal, id: idNamespace })),
                React.createElement(FAQ, { deal: deal }),
                React.createElement(ContactInfo, { deal: deal }),
                this.showImportantInfo() && (React.createElement(Col, { lgHidden: true, mdHidden: true, sm: 12, xs: 12 },
                    React.createElement(DealImportantInfoContainer, { user: user, deal: deal, isInline: true }))))));
    };
    DealInfoBlock.defaultProps = {
        deal: {}
    };
    return DealInfoBlock;
}(React.PureComponent));
export default withBranding(DealInfoBlock);
